export default "__VITE_ASSET__BK$K77Nl__"